import { isUndefined } from 'util';
import { Observable } from 'rxjs/Observable';
import { isNullOrUndefined } from 'util';
import { AfterContentInit, AfterViewInit, Component, OnInit, OnDestroy, Inject, Renderer2 } from '@angular/core';
import { FormsService } from '../../providers/forms.service';
import { ScrollService } from '../../providers/scroll.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseService } from '../../providers/firebase.service';
import { FirebaseListObservable } from "angularfire2/database-deprecated";
import { LocationInfo } from "../../models/locationInfo";
import { Client } from "../../models/client";
import { Form } from '../../models/forms';
import { FormData } from '../../models/formData';
import { AWSConnectorService } from '../../providers/aws-connector';
import * as _ from 'lodash';
import { LoadingServiceProvider } from '../../providers/loading-service';
import { DOCUMENT } from '@angular/common';

declare const swal: any;

@Component({
  selector: 'app-forms-create-leases',
  templateUrl: './forms-create-leases.component.html',
  styleUrls: ['./forms-create-leases.component.css']
})
export class FormsCreateLeasesComponent implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {
  key: string;
  locKey: string;
  path: string;
  locationForms: FirebaseListObservable<FormData[]>;
  locationFormsArray: FormData[];
  clientData: Client = new Client;
  locationData: LocationInfo = new LocationInfo;
  moveInFormsToggleDisabled = true;
  allForms: Observable<Array<Form>>;
  leaseTypes = {
    "pugSign": false,
    "helloSign": false,
    "blueMoon": false,
    "sitelink": false
  };

  allUnits: any;
  unitTypes = [];

  availableUnitsByUnitTypeData = [];
  selectedUnitId = 'nope';
  leasePreviewUrl: string;

  constructor(
    public forms: FormsService,
    public route: ActivatedRoute,
    public afService: FirebaseService,
    public router: Router,
    private scroll: ScrollService,
    private loading: LoadingServiceProvider,
    private awsConn: AWSConnectorService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: any,
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.key = params['key'];
      this.locKey = params['locKey'];
      this.path = '/clients/' + this.key + '/locations/' + this.key + '/' + this.locKey;
      this.afService.getClientInfo(this.key).subscribe((clientData) => {

        this.afService.getLocationInfo(this.key, this.locKey).subscribe(locationData => {
          this.clientData = clientData;
          if (locationData.moveInContractType == 'sitelink') {
            this.getUnitTypeData();
          }
          // this.allForms = this.forms.getAllForms(this.clientData.propertySoftware, this.locKey, this.clientData.code);
          this.locationData = locationData;
          if (isUndefined(this.locationData.moveInContract)) {
            this.locationData.moveInContract = [];
          }

          if (isNullOrUndefined(this.locationData.moveInContractType)) {
            this.locationData.moveInContractType = 'pugSign';
            this.leaseTypes.pugSign = true;
          }
          else {
            if (this.locationData.moveInContractType == 'sitelink') {
              this.leaseTypes.sitelink = true;
            }
            else if (this.locationData.moveInContractType == 'blueMoon') {
              this.leaseTypes.blueMoon = true;
            }
            else if (this.locationData.moveInContractType == 'helloSign') {
              this.leaseTypes.helloSign = true;
            }
            else {
              this.leaseTypes.pugSign = true;
            }
          }

          this.locationForms = this.afService.getLocationForms(this.key, this.locKey);
          let sub = this.locationForms.subscribe((data: any) => {
            console.log(data);
            sub.unsubscribe();
            if (data == null)
              data = [];
            this.locationFormsArray = data;

            this.forms.getObjectFromFirebase(`unitTypes/${ this.locKey }`, this.clientData.code).toPromise().then((types) => {
              this.unitTypes = types;
              for (let item of this.locationFormsArray) {
                if (item.units) {
                  for (let k of item.units) {
                    let count = 0;
                    for (let i of this.unitTypes) {
                      if (i.id == k.id) {
                        this.unitTypes.splice(count, 1);
                      }
                      count++;
                    }
                  }
                }
              }

              console.log(this.locationFormsArray)
            });
          });
        });
      });
    });
  }

  ngAfterViewInit() {
    this.scroll.scrollToTop();
  }

  ngOnDestroy() {
    if (this.locationData.moveInContractType == 'pugSign' && this.unitTypes.length > 0) {
      this.locationData.showMoveInContract = false;
      this.afService.updateClientForms(this.locationData, this.key, this.locKey).then(() => {
      });
    }
  }

  ngAfterContentInit() {
    this.moveInFormsToggleDisabled = this.unitTypes.length > 0;
  }

  testSitelinkEsign() {
    if (this.selectedUnitId === 'nope') {
      this.afService.openSnackBar('SELECT A UNIT!!!!!!!!');
      console.warn('idiot...');
    }
    else {
      this.leasePreviewUrl = undefined;
      this.loading.showLoading();
      this.awsConn.eSignLeasePreviewUrl(this.clientData.code, this.locKey, this.selectedUnitId)
        .subscribe(
          data => {
            console.log(data);
            if (data['Ret_Code'] < 0) {
              console.error(data);
              this.afService.openSnackBar(`ERROR: ${ data['Ret_Msg'] }`, null, 6000);
            }
            else {
              this.leasePreviewUrl = data['Ret_Msg'];
            }
          },
          error => {
            this.afService.openSnackBar(error.message);
            console.error(error);
          },
          () => this.loading.hideLoading()
        );
    }
  }

  async getUnitTypeData() {
    this.availableUnitsByUnitTypeData = await new Promise<any[]>((resolve, reject) => {
      const table = `availableUnits/${ this.locKey }/availableUnitsByUnitTypeData`;
      this.awsConn.getObjectFromFirebase(this.clientData.code, table)
        .subscribe(resolve, reject);
    });
  }

  createForm() {
    this.afService.newLocationForm(this.key, this.locKey, new FormData()).then((data) => {
      // console.log(data)
      // let newForm = this.locationFormsArray[this.locationFormsArray.length - 1];
      this.router.navigate([`../forms/${ data.key }`], { relativeTo: this.route });
    });
  }

  setLeaseType(type) {
    if (type == 'blueMoon') {
      this.leaseTypes.blueMoon = true;
      this.leaseTypes.sitelink = false;
      this.leaseTypes.pugSign = false;
      this.leaseTypes.helloSign = false;
    }
    else if (type == 'sitelink') {
      this.getUnitTypeData();
      this.leaseTypes.sitelink = true;
      this.leaseTypes.pugSign = false;
      this.leaseTypes.blueMoon = false;
      this.leaseTypes.helloSign = false;
    }
    else if (type == 'helloSign') {
      this.leaseTypes.pugSign = false;
      this.leaseTypes.sitelink = false;
      this.leaseTypes.blueMoon = false;
      this.leaseTypes.helloSign = true;
    }
    else {
      this.leaseTypes.pugSign = true;
      this.leaseTypes.sitelink = false;
      this.leaseTypes.blueMoon = false;
      this.leaseTypes.helloSign = false;
    }
    this.locationData.moveInContractType = type;
    return this.afService.updateClientForms(this.locationData, this.key, this.locKey).then((data) => {
      this.afService.openSnackBar('Updated.');
    });
  }

  saveClientForms() {
    this.afService.updateClientForms(this.locationData, this.key, this.locKey).then((data) => {
      this.afService.openSnackBar('Updated.');
    });
  }

  updateLocationForm(lease) {
    return this.afService.updateLocationForm(this.key, this.locKey, lease).then((data) => {
      this.afService.openSnackBar('Updated.');
    });
  }

  updateClientFormsToggle(tableName, e) {
    this.locationData[tableName] = e.checked;
    return this.afService.updateClientForms(this.locationData, this.key, this.locKey).then((data) => {
      this.afService.openSnackBar('Successfully saved esign Settings.');
    });
  }

  updateDefaultLease(e, lease) {
    console.log(e)
    console.log(lease)
    lease.isDefault = e.checked;
    this.updateLocationForm(lease);
    // return this.afService.updateClientForms(this.locationData, this.key, this.locKey).then((data) => {
    //   this.afService.openSnackBar('Successfully saved esign Settings.');
    // });
  }

  addUnitTypeToLease(e, lease) {
    this.removeTypeFromLeases(e.dragData);

    lease.units.unshift(e.dragData);
    let count = 0;
    for (let i of this.unitTypes) {
      if (i.id == e.dragData.id) {
        this.unitTypes.splice(count, 1);
      }
      count++;
    }
    this.updateLocationForm(lease);
  }

  removeTypeFromLeases(type) {
    console.log(type)
    for (let i of this.locationFormsArray) {
      let count = 0;
      if (isNullOrUndefined(i.units)) {
        i.units = [];
      }
      for (let t of i.units) {
        if (t.id == type.id) {
          i.units.splice(count, 1);
          return true;
        }
        count++;
      }
    }
    return true;
  }

  addUnitTypeToUnitTypes(e) {
    this.removeTypeFromLeases(e.dragData);
    let count = 0;
    for (let i of this.unitTypes) {
      if (i.id === e.dragData.id) {
        this.unitTypes.splice(count, 1);
      }
      count++;
    }
    this.unitTypes.unshift(e.dragData);
    let promiseArray = [];
    for (let form of this.locationFormsArray)
      promiseArray.push(this.updateLocationForm(form));

    Promise.all(promiseArray);
  }

  updateLocation() {
    this.afService.updateLocation(this.clientData, this.locationData).then(() => {
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
  }

  deleteForm(form) {
    console.log('form:', form, 'this.locationFormsArray:', this.locationFormsArray);
    // this.afService.openSnackBar('this doesn\'t actually work :(');

    if (form.units) {
      for (const unit of form.units) {
        this.removeTypeFromLeases(unit);
      }
    }

    this.afService.removeLocationForm(this.key, this.locKey, form).then(() => {
      // this.afService.openSnackBar('Successfully saved esign Settings.');
      this.afService.openSnackBar('this is still kind of broken, refresh the page');
    }).catch(e => {
      this.afService.openSnackBar(e.message);
    });
  }

  copyUrlToClipboard() {
    const copyText = this.document.getElementById('lease-url-input');
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    this.document.execCommand('copy');

    const tooltip = document.getElementById('tooltip-action-text');
    this.renderer.setProperty(tooltip, 'innerHTML', `Copied: ${ copyText.value }`);
  }

  outFunc() {
    const tooltip = document.getElementById('tooltip-action-text');
    this.renderer.setProperty(tooltip, 'innerHTML', `Copy to clipboard`);
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }

  // checkToggle() {
  //   console.log('checkToggle()');
  //   if (this.unitTypes.length > 0) {
  //     this.locationData.showMoveInContract = false;
  //     this.moveInFormsToggleDisabled = true;
  //     this.afService.updateClientForms(this.locationData, this.key, this.locKey).then(() => {
  //     });
  //   }
  //   // else
  //   // this.moveInFormsToggleDisabled = false;
  // }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/forms-create-leases/forms-create-leases.component.ts